import { useEffect, useState } from "react";

const useLocalizePhrase = (phrase: string): string => {
    const [translatedPhrase, setTranslatedPhrase] = useState<string>(phrase);

    useEffect(() => {
        let attemptsLeft = 20;
        let timer: number;

        const translatePhrase = () => {
            const Localize = (window as any).Localize;

            if (!Localize || typeof Localize.translate !== 'function') {
                attemptsLeft -= 1;

                if (attemptsLeft > 0) {
                    timer = window.setTimeout(translatePhrase, 300);
                }

                return;
            }

            Localize.translate(phrase, function(translation: string){
                setTranslatedPhrase(translation || phrase);
            });
        };

        translatePhrase();
        
        return () => {
            window.clearTimeout(timer);
        };
    }, [phrase]);

    return translatedPhrase;
};

export default useLocalizePhrase;